import React, {useState, useEffect, useContext} from "react";
import {scroller, animateScroll} from "react-scroll";
import axios from "../common/axios";
import ListItem, {ICON_TYPES} from "../common/ListItem";
import ListGroup from "../common/ListGroup";
import {UserContext} from "../common/UserContext";
import {TemplateContext} from "../common/TemplateContext";
import {ContentContext} from "../common/ContentContext";
import {AudioIcon, DownloadFileIcon, ExampleIcon, TextbookIcon, ReviewIcon, TryItIcon, VideoIcon, WidgetIcon, WorksheetIcon, WorksheetSolutionIcon} from "../common/icons";
import CircularLoader from "../common/CircularLoader";

const ResourceNavigation = props => {
    const {indicatorPlacement, tabIndex = 0} = props;
    const {user, setUser} = useContext(UserContext);
    const {shortcutLocation} = useContext(TemplateContext);
    const {content} = useContext(ContentContext);
    const [resourceGroups, setResourceGroups] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const loadResources = (conceptId) => {
        setLoading(true);
        axios.get('/web/ui/content/concept/resources', {params: {conceptId: conceptId}})
            .then(response => {
                setResourceGroups(response.data);
            }).catch(e => {
                console.error('Error loading resources', e);
            }).finally(() => {
                setLoading(false);
            });
    }
    let otherListGroupOptions  = {}
    if (indicatorPlacement) otherListGroupOptions.indicatorPlacement = indicatorPlacement;

    useEffect(() => {
        if(content.currentConcept !== undefined) {
            loadResources(content.currentConcept.conceptId);
        }
    }, [content, shortcutLocation]);

    if(resourceGroups === undefined || resourceGroups.length == 0) {
        return null;
    }

    const handleScrollToExample = (exampleNum) => {
        closeDialogs();
        var $exampleBox = $(".box-example[value='" + exampleNum + "']");
        if($exampleBox.size() == 0) {
            $exampleBox = $(".example[value='" + exampleNum + "']");
        }
        if($exampleBox.size() == 0) {
            $exampleBox = $(".cont-example-anchor[data-example-num='" + exampleNum + "']");
        }

        if($exampleBox.size() > 0) {
            if($exampleBox.hasClass('close')) {
                $('.examp-head, .exampleHead, .box-heading', $exampleBox).trigger('click');
            }
            $('.cont-block-accordion', $exampleBox).addClass('cont-block-accordion-show');

            var scrollPos = $exampleBox.offset().top - 50;
            var $content = $('#contentPanel');

            $content.scrollTop($content.scrollTop() - $content.offset().top + scrollPos);

            return true
        }

        return false;
    }

    if(isLoading) {
        return <CircularLoader pageCentered={true} displayInElement={true}/>;
    }

    return resourceGroups.map((resourceGroup, groupIndex) => {
        if(resourceGroup.resources === undefined) {
            return null;
        }

        return (
            <ListGroup key={groupIndex} tabIndex={groupIndex == 0 ? 0 : -1} title={resourceGroup.name} className={resourceGroup.styleClass} itemCount={resourceGroup.resources.length} startOpen={false} {...otherListGroupOptions}>
                {resourceGroup.resources.map((resource, index) => {
                    const {name, iconClass, iconId} = resource;

                    const handleOnClick = () => {
                        if(resource.resourceType == 'QUESTION') {
                            loadDialogTryIt(resource.questionId, resource.conceptId);
                        } else if(resource.resourceType == 'TUTORIAL' && resource.tutorialSubType == 'EXAMPLE') {
                            if(!handleScrollToExample(resource.exampleNum)) {
                                if(resource.conceptId && resource.tutorialId && resource.featureFlag) {
                                    openExampleDialog(resource.conceptId, resource.tutorialId, resource.exampleNum, resource.name);
                                } else if(resource.conceptId && resource.exampleNum) {
                                    openExampleDialogByExampleNum(resource.conceptId, resource.exampleNum);
                                }
                            }
                        } else if(resource.resourceType == 'TUTORIAL' && resource.tutorialSubType == 'LESSON_CONTENT') {
                            openReviewDialog(resource.tutorialId, resource.name);
                        } else if(resource.resourceType == 'MEDIA' && resource.mediaType == 'WIDGET') {
                            openWidgetDialog(resource.mediaId);
                        } else if(resource.resourceType == 'MEDIA' && resource.mediaType == 'DESMOS' && resource.mediaSubType == 'DESMOS_GRAPHING') {
                            loadGraphingCalculator(resource.mediaId);
                        } else if(resource.resourceType == 'MEDIA' && resource.mediaType == 'DESMOS' && resource.mediaSubType == 'DESMOS_GEOMETRY') {
                            loadGeometryCalculator(resource.mediaId);
                        } else if(resource.resourceType == 'MEDIA' && resource.mediaType == 'DESMOS' && resource.mediaSubType == 'DESMOS_SCIENTIFIC') {
                            loadScientificCalculator(resource.mediaId);
                        } else if(resource.resourceType == 'MEDIA' && resource.mediaType == 'DESMOS' && resource.mediaSubType == 'DESMOS_MATRIX') {
                            loadMaxtrixCalculator(resource.mediaId);
                        } else if(resource.resourceType == 'MEDIA' && resource.mediaType == 'VIDEO') {
                            openVideoDialog(resource.mediaId);
                        } else if(resource.resourceType == 'MEDIA' && (resource.mediaType == 'WORKSHEET' || resource.mediaType == 'TEXTBOOK' || resource.mediaType == 'COURSE_DOCUMENTATION')) {
                            window.open(resource.url, '_blank')
                        }
                    }
                    const Icons = {
                        'example-icon': ExampleIcon,
                        'tryit-icon': TryItIcon,
                        'video-icon': VideoIcon,
                        'video': VideoIcon,
                        'audio-icon': AudioIcon,
                        'widget-icon': WidgetIcon,
                        'worksheet-icon': WorksheetIcon,
                        'worksheet-solution-icon': WorksheetSolutionIcon,
                        'file-download-word': DownloadFileIcon,
                        'file-download-pdf': DownloadFileIcon,
                        'file-download-powerpoint': DownloadFileIcon,
                        'textbook-icon': TextbookIcon,
                        'review-icon': ReviewIcon
                    }

                    return (
                        <ListItem key={index} tabIndex={index == 0 ? 0 : -1} icon={Icons[iconId]} iconType={ICON_TYPES.REACT_ICON} onClick={handleOnClick}>
                            <span  dangerouslySetInnerHTML={{ __html: name}}></span>
                        </ListItem>
                    )
                })}
            </ListGroup>);
    });
}

export default ResourceNavigation;